import React from 'react';
import PropTypes from 'prop-types';
import InputCalc from '../../../../../../components/UIComponents/Fields/InputCalc';


const HollowCircleSection = ({
  inputs,
  changeInputValue,
  sectionType,
  optionsLengthUnits
}) => {
  return (
    <div>
      <InputCalc
        input={inputs.D}
        inputs={inputs}
        field={sectionType}
        changeInput={changeInputValue}
        unitList={optionsLengthUnits}
      />
      <InputCalc
        input={inputs.t}
        inputs={inputs}
        field={sectionType}
        changeInput={changeInputValue}
        unitList={optionsLengthUnits}
      />
    </div>
  );
};

export default HollowCircleSection;
